import React from 'react';

// Componente para a seção "Diferencial" com mais elementos visuais
const Diferencial: React.FC = () => {
  return (
    <section id="diferencial" className="py-20 bg-white dark:bg-gray-900 relative overflow-hidden">
      {/* Elementos decorativos de fundo */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-lupa-orange/5 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-lupa-orange/5 rounded-full translate-x-1/3 translate-y-1/3"></div>
      <div className="absolute top-1/2 left-1/4 w-8 h-8 bg-lupa-orange/10 rounded-full"></div>
      <div className="absolute top-1/3 right-1/4 w-12 h-12 bg-lupa-orange/10 rounded-full"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="section-title">Especialistas em centralização, dados e IA</h2>
          <p className="section-subtitle">
            Utilizando métodos inovadores e técnicas avançadas de Inteligência Artificial, 
            nós não apenas descobrimos conexões entre os dados, mas também oferecemos um 
            entendimento mais profundo sobre o que essas conexões significam para o seu negócio.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Card 1 - Com elementos visuais adicionais */}
          <div className="card group hover:scale-105 transition-all duration-300 relative">
            {/* Elemento decorativo */}
            <div className="absolute -top-3 -right-3 w-12 h-12 bg-lupa-orange/10 rounded-full z-0 group-hover:bg-lupa-orange/20 transition-all duration-300"></div>
            
            <div className="relative z-10">
              <div className="h-16 w-16 rounded-full bg-lupa-orange/20 dark:bg-lupa-orange/10 flex items-center justify-center mb-6 group-hover:bg-lupa-orange/30 transition-all duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-lupa-orange" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-3">Centralização de Dados</h3>
              <p className="text-gray-600 dark:text-gray-300">
                Unificamos todas as suas fontes de dados em uma única plataforma, 
                eliminando silos e facilitando o acesso às informações relevantes.
              </p>
              
              {/* Lista de benefícios */}
              <ul className="mt-4 space-y-2">
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-600 dark:text-gray-300 text-sm">Acesso unificado a todos os dados</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-600 dark:text-gray-300 text-sm">Eliminação de redundâncias</span>
                </li>
              </ul>
            </div>
          </div>
          
          {/* Card 2 - Com elementos visuais adicionais */}
          <div className="card group hover:scale-105 transition-all duration-300 relative">
            {/* Elemento decorativo */}
            <div className="absolute -top-3 -right-3 w-12 h-12 bg-lupa-orange/10 rounded-full z-0 group-hover:bg-lupa-orange/20 transition-all duration-300"></div>
            
            <div className="relative z-10">
              <div className="h-16 w-16 rounded-full bg-lupa-orange/20 dark:bg-lupa-orange/10 flex items-center justify-center mb-6 group-hover:bg-lupa-orange/30 transition-all duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-lupa-orange" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-3">Inteligência Artificial</h3>
              <p className="text-gray-600 dark:text-gray-300">
                Aplicamos algoritmos avançados de IA para identificar padrões, 
                prever tendências e gerar insights que impulsionam decisões estratégicas.
              </p>
              
              {/* Lista de benefícios */}
              <ul className="mt-4 space-y-2">
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-600 dark:text-gray-300 text-sm">Previsões baseadas em dados históricos</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-600 dark:text-gray-300 text-sm">Automação de processos decisórios</span>
                </li>
              </ul>
            </div>
          </div>
          
          {/* Card 3 - Com elementos visuais adicionais */}
          <div className="card group hover:scale-105 transition-all duration-300 relative">
            {/* Elemento decorativo */}
            <div className="absolute -top-3 -right-3 w-12 h-12 bg-lupa-orange/10 rounded-full z-0 group-hover:bg-lupa-orange/20 transition-all duration-300"></div>
            
            <div className="relative z-10">
              <div className="h-16 w-16 rounded-full bg-lupa-orange/20 dark:bg-lupa-orange/10 flex items-center justify-center mb-6 group-hover:bg-lupa-orange/30 transition-all duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-lupa-orange" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-3">Soluções Personalizadas</h3>
              <p className="text-gray-600 dark:text-gray-300">
                Desenvolvemos soluções sob medida para os desafios específicos do seu negócio, 
                garantindo resultados alinhados com seus objetivos estratégicos.
              </p>
              
              {/* Lista de benefícios */}
              <ul className="mt-4 space-y-2">
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-600 dark:text-gray-300 text-sm">Adaptação às necessidades específicas</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-600 dark:text-gray-300 text-sm">Escalabilidade conforme seu crescimento</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        {/* Citação inspiradora com design destacado */}
        <div className="mt-16 bg-gradient-to-r from-lupa-orange/10 to-lupa-yellow/10 dark:from-lupa-orange/5 dark:to-lupa-yellow/5 p-8 rounded-xl border border-lupa-orange/20 relative">
          <div className="absolute -top-5 -left-5 text-lupa-orange/20 dark:text-lupa-orange/10">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16" fill="currentColor" viewBox="0 0 24 24">
              <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
            </svg>
          </div>
          <div className="text-center">
            <p className="text-lg text-gray-700 dark:text-gray-200 italic font-medium mb-4">
              Na Lupa Data, acreditamos que a chave para o futuro está nos dados. 
              Estamos aqui para ajudar você a desbloquear esse potencial e transformar 
              informações em vantagem competitiva.
            </p>
            <a href="#solucoes" className="btn-primary inline-block">Conheça nossas soluções</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Diferencial;
